import { createBrowserHistory } from 'history';
import { createEvent, createStore } from 'effector';

export const history = createBrowserHistory();

// The fetcher stores a failed request's status in location state so
// AppErrorHandler can show an error page. Browsers keep history state across
// reloads, so drop any status left over from a previous page load; otherwise a
// refresh keeps showing the error page even after the request succeeds.
if (history.location.state && history.location.state.errorStatusCode) {
  const { errorStatusCode, ...state } = history.location.state;
  const { pathname, search, hash } = history.location;
  history.replace(`${pathname}${search}${hash}`, state);
}

const changeLocation = createEvent('location changed');

/**
 * Current location effector store
 */
export const $location = createStore(history.location).on(
  changeLocation,
  (_, location) => location,
);

history.listen(changeLocation);
